export default __webpack_public_path__ + "static/media/iMoto.6ba01da1.mov";